<template>
	<div class="RecetaPasosHandler">
        
        <b-jumbotron v-if="workingValue.length == 0" header="No hay pasos" lead="Agrega al menos uno para continuar" />

		<b-card v-for="(item, $index) in workingValue" :key="$index">
			<b-row>
				<b-col md="9">
					<b-form-input v-model="item.nombre" placeholder="Nombre del proceso (Título)" :state="!!item.nombre"></b-form-input>
				</b-col>

				<b-col class="title mb-2 mt-1">
					<b-button-group block size="sm" class="mr-3">
						<b-button variant="info" disabled>{{$index + 1}}</b-button>
						<b-button v-if="$index > 0" @click="swipe($index-1, $index)">
							<i class="fa fa-chevron-up"></i>
						</b-button>
						<b-button v-if="workingValue.length >= ($index + 2) " @click="swipe($index+1, $index)">
							<i class="fa fa-chevron-down"></i>
						</b-button>
						<b-button variant="outline-danger" @click="removeStep($index)">
							<i class="fa fa-trash"></i>
						</b-button>
					</b-button-group>
				</b-col>

				<b-col class="desc" md="12">
					<b-form-textarea class="mt-3" v-model="item.descripcion" :state="!!item.descripcion" rows="3" max-rows="6"></b-form-textarea>
				</b-col>
			</b-row>
		</b-card>

		<b-card class="mb-0">
			<b-input-group size="sm">
				<template #prepend> <b-input-group-text>Agrega un paso</b-input-group-text> </template>
				<b-form-input v-model="form.nombre" placeholder="Título del proceso" :state="(form.nombre == null) ? null : (form.nombre.length > 1) ? true : false"></b-form-input>
			</b-input-group>

			<b-form-textarea v-if="form.nombre != null" class="mt-3" v-model="form.descripcion" placeholder="Describe el proceso" rows="3" max-rows="6" :state="(form.descripcion == null) ? null : (form.descripcion.length > 1) ? true : false"></b-form-textarea>

			<div class="align-right mt-3" v-if="form.descripcion != null || form.nombre != null">
				<b-button variant="outline-danger" @click="cleanForm()">Limpiar</b-button>&nbsp;
				<b-button variant="primary" @click="addItem()">Agregar paso</b-button>
			</div>
		</b-card>
	</div>
</template>

<script>
import swal from "sweetalert";
import _ from "lodash";

let emptyPaso = {
	id_pk: null,
	numero: null,
	nombre: null,
	descripcion: null,
	id_encabezado_fk: null,
	id_ultimo_usuario_fk: null,
	ultima_actualizacion: null,
};

let unempties = "nombre,descripcion".split(",");

export default {
	name: "RecetaPasosHandler",
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	data: () => {
		return {
			workingValue: [],
			form: _.clone(emptyPaso),
		};
	},
	computed: {
		emitingValue() {
			let emmittingValue = _.clone(this.workingValue);
			let isValid = true;
			_.map(emmittingValue, (item, indx) => {
				_.forEach(unempties, (label) => {
					if (!item[label]) isValid = false;
				});
				item.numero = indx + 1;
			});
			if (isValid) this.$emit("input", emmittingValue);
			else this.$emit("input", []);
		},
	},
	methods: {
        swipe(newIndex, $index) {
            let newArray = []
            _.forEach(this.workingValue, (item, index) => {
                if(index != $index){
                    if(index == newIndex){
                        if(newIndex>$index)
                            newArray.push(_.clone(item))
                        newArray.push(_.clone(this.workingValue[$index]))
                        if(newIndex<$index)
                            newArray.push(_.clone(item))
                    } else {
                        newArray.push(_.clone(item))
                    }
                }
            })
            this.workingValue = newArray
        },
		async removeStep($index) {
			let responseSwal = await swal({
				title: "¿Seguro que deseas eliminar éste paso?",
				buttons: {
					cancel: "Cancelar",
					danger: "Eliminar paso",
				},
			});
			if (responseSwal == "danger") {
				this.workingValue.splice($index, 1);
				// this.$emit('input', data2emmit.splice($index, 1))
			}
		},
		addItem() {
			let data2add = _.clone(this.form),
				canContinue = true;
			_.forEach(unempties, (label) => {
				if (!data2add[label]) {
					canContinue = false;
				}
			});
			if (!canContinue) {
				swal({
					icon: "info",
					title: "Para continuar debes definir el título y el contenido del mensaje",
				});
			} else {
				this.workingValue.push(data2add);
				this.cleanForm();
			}
		},
		cleanForm() {
			this.form = _.clone(emptyPaso);
		},
		addEmptyPaso() {
			this.workingValue.push(_.clone(emptyPaso));
		},
	},
	watch: {
		emitingValue() {
			this.$emit("input", this.emitingValue);
		},
	},
	beforeMount() {
		this.workingValue = _.clone(this.value);
	},
};
</script>

<style lang="less">
.RecetaPasosHandler {
	.align-right {
		text-align: right;
	}
}
</style>